export enum CONTINUOUS_TYPES {
  CONTINUOUS = 'CONTINUOUS',
  SNAPSHOT_UNLIMITED = 'SNAPSHOT_UNLIMITED',
}
